// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___4ZOS6"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/canvas/ui/components/canvas-item/style.css
// module id = 1363
// module chunks = 0